<script setup lang="ts">
import type {NewsInterface} from "#server/types/NewsInterface";


 defineProps<{
    list: NewsInterface[];
}>();

import {localDateFormat} from "~/services/helpers";



</script>


<template>
  <div class="row">
    <div
        class="col-lg-3 col-12 col-sm-6 mb-5 d-flex flex-column"
        v-for="item of list"
    >
      <NuxtLinkLocale :to="item.url">
        <img
            :src="item?.photo"
            :alt="item.name"
            :title="item.name"
            decoding="async"
            loading="eager"
            class="grid-image-news"
        >
      </NuxtLinkLocale>

      <div class="news-grid p-3">
        <div class="title-news-grid fs-0 text-center fw-bold">
          <NuxtLinkLocale :to=" item.url">
            {{ item.name }}
          </NuxtLinkLocale>
        </div>

        <div
            v-if="item.short_description"
            class="short-description-grid pt-3 fs--11"
        >
          {{ item.short_description }}
        </div>
      </div>

      <div class="news-grid-footer align-items-center px-3 py-2">
        <div class="date fs-0 fw-semibold d-flex align-items-center">
          <Icon
              class="me-1"
              v-if="item.news_date"
              name="material-symbols-light:calendar-month-rounded"
              size="20"
          />

          {{ localDateFormat(item.news_date) }}
        </div>

        <div class="read-more">
          <NuxtLinkLocale
              :to="item.url"
              class="el-button el-button--primary el-button--small is-round"
          >
            {{ $t('preview') }}
          </NuxtLinkLocale>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.grid-image-news{
  border-radius: 8px 8px 0 0 ;
  box-shadow: 0 4px 8px rgba(0, 0, 0, .1) ;
  height: 230px ;
  -o-object-fit: cover;
  object-fit: cover ;
  width: 100% ;
  display: block;
}
.news-grid{
  border: 1px solid var(--el-color-info-light-8);
  flex: 1 1 auto;
}
.news-grid-footer{
  border: 1px solid var(--el-color-info-light-8);
  border-top: none;
  display: flex;
  justify-content: space-between;
}
.short-description-grid{
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2rem;

  text-align: justify !important;
}
.title-news-grid{
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>